import usePhotoDetailStore from "../stores/usePhotoDetailStore";

const useIsSettledPhotoCaughtUp = () => {
	const isSettledPhotoCaughtUp = usePhotoDetailStore(
		(state) =>
			state.debouncedCurPhoto &&
			state.curPhoto &&
			state.debouncedCurPhoto.photoId === state.curPhoto.photoId,
	);
	return isSettledPhotoCaughtUp;
};
export default useIsSettledPhotoCaughtUp;
